import { render, staticRenderFns } from "./paparanutama.vue?vue&type=template&id=52d4551a"
import script from "./paparanutama.vue?vue&type=script&lang=js"
export * from "./paparanutama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports